<ndt-incoming-fax-register-view
   [callState]="callState$ | async"
   [dataSource]="dataSource$ | async"
   [isLoading]="isLoading$ | async"
   [hasNextPage]="hasNextPage$ | async"
   [pagingCallState]="pagingCallState$ | async"
   [totalCount]="totalCount$ | async"
   [name]="entityName"
   [columns]="columns"
   [showCreate]="false"
   [hideHeader]="true"
   (openDialog)="onOpenDialog($event)"
   (quickFilterChange)="onQuickFilterChange($event)"
   (orderingOptionsChange)="onOrderingOptionsChange($event)"
   [orderingOptions]="orderingOptions$ | async"
   (loadMore)="onLoadMore()"
>
</ndt-incoming-fax-register-view>
